// Acciones de la columna "WhatsApp 2ª parte" de Postulaciones (postulación por
// etapas). Las dos registran en el backend el usuario de la sesión.
//
//   POST {APPLICANT}/application/stage-invitation-send-now/{applicationId}?userId=<id>
//   → { message, status }   el WhatsApp PROGRAMADO se envía ya
//   POST {APPLICANT}/application/stage-invitation-extend/{applicationId}?userId=<id>  { hours? }
//   → { message, expiresAt, hours }   el enlace vencido vuelve a funcionar (mismo token);
//     sin `hours` queda sin vencimiento (expiresAt/hours null): solo se cierra al completar

import { readApiErrorMessage } from "../components/pages/Postulaciones/postulacionesUtils";

export interface IAccionInvitacionResult {
  message: string;
  expiresAt?: string | null;
  hours?: number | null;
}

const buildUrl = (resource: string, applicationId: string): string => {
  const userId = sessionStorage.getItem("usuarioId") ?? "";
  const baseUrl = process.env.REACT_APP_API_APPLICANT;
  if (!baseUrl) throw new Error("Configuración faltante: REACT_APP_API_APPLICANT.");
  return `${baseUrl}/application/${resource}/${encodeURIComponent(applicationId)}?userId=${encodeURIComponent(userId)}`;
};

const post = async (resource: string, applicationId: string, body: object = {}): Promise<IAccionInvitacionResult> => {
  const res = await fetch(buildUrl(resource, applicationId), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });

  if (!res.ok) {
    throw new Error(await readApiErrorMessage(res));
  }

  return (await res.json()) as IAccionInvitacionResult;
};

export const enviarInvitacionAhora = (applicationId: string): Promise<IAccionInvitacionResult> =>
  post("stage-invitation-send-now", applicationId);

/** Sin `hours`, el backend deja el enlace sin vencimiento (solo se cierra al completar). */
export const extenderInvitacion = (applicationId: string, hours?: number): Promise<IAccionInvitacionResult> =>
  post("stage-invitation-extend", applicationId, hours ? { hours } : {});
